import emailSortingCompany from './email_sorting_company'
import speechWritingMill from './speech_writing_mill'
import coldCallCenter from './cold_call_center'
import pollAnalysisLab from './poll_analysis_lab'
import focusGroups from './focus_groups'
import merchandiseFactory from './merchandise_factory'
import superPACs from './super_pacs'
import predictionMarket from './prediction_market'
import celebrityBookingAgency from './celebrity_booking_agency'
import luxuryConferenceRooms from './luxury_conference_rooms'
import privateSecurity from './private_security'
import socialMediaBotFarm from './social_media_bot_farm'
import fakeNewsNetwork from './fake_news_network'
import dataMiningFirm from './data_mining_firm'
import electionMachines from './election_machines'
import espionageAcademy from './espionage_academy'
import smugglingNetwork from './smuggling_network'
import diplomacySyndicate from './diplomacy_syndicate'
import brandingGroup from './branding_group'
import deepStateVentures from './deep_state_ventures'
import climateControlCorporation from './climate_control_corporation'
import campaignThemeParks from './campaign_theme_parks'
import interstellarAdvertising from './interstellar_advertising'
import type { Upgrade } from '../../../../types/Upgrade'

const array: Upgrade[] = [
	...emailSortingCompany,
	...speechWritingMill,
	...coldCallCenter,
	...pollAnalysisLab,
	...focusGroups,
	...merchandiseFactory,
	...superPACs,
	...predictionMarket,
	...celebrityBookingAgency,
	...luxuryConferenceRooms,
	...privateSecurity,
	...socialMediaBotFarm,
	...fakeNewsNetwork,
	...dataMiningFirm,
	...electionMachines,
	...espionageAcademy,
	...smugglingNetwork,
	...diplomacySyndicate,
	...brandingGroup,
	...deepStateVentures,
	...climateControlCorporation,
	...campaignThemeParks,
	...interstellarAdvertising
]

export default array
